import React from "react";
import { PowerEvolutionContainer } from "../../container/panelReports";

const PowerEvolutionScreen: React.FC<{}> = () => {
  return <PowerEvolutionContainer/>;
}

export default PowerEvolutionScreen;